module.exports = "/_next/static/resources/photo-3-ce51f201fcc484f6cb3047c30e9a4961.webp";